import { BillingSheet } from '@/types/billing'
import ConfirmAndPay from './ConfirmAndPay'

const PaymentUI = ({ billingSheet }: { billingSheet: BillingSheet }) => (
  <ConfirmAndPay billingSheet={billingSheet} />
)

export default PaymentUI
